import { Select } from "antd";
import React, { useCallback } from "react";
import { Option } from "../../common/forms/Interfaces";

interface Props<Value extends string | number> {
  items: Option<Value>[];
  onChange?: (value: Value) => void;
  defaultValue?: Value;
  placeholder?: string;
}

const renderOptions = (options: Option[]): React.ReactElement[] => {
  return options.map((option) => (
    <Select.Option disabled={option.disabled} key={option.value} value={option.value}>
      {option.title}
    </Select.Option>
  ));
};

const SelectFilter = <Value extends string | number = string | number>({ items, onChange, defaultValue, placeholder }: Props<Value>) => {
  const onChangeHandler = useCallback(
    (value: Value) => {
      if (onChange) {
        onChange(value);
      }
    },
    [onChange]
  );

  return (
    <Select
      onChange={onChangeHandler}
      showSearch
      placeholder={placeholder || ''}
      className="select-filter"
      defaultValue={defaultValue}
      filterOption={(input, option) => {
        if (!option) {
          return false;
        }

        return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
      }}
    >
      {renderOptions(items)}
    </Select>
  );
};

export default SelectFilter;
